module.exports = __webpack_public_path__ + "img/effectnode-webby.a4e265f5.png";